import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-267c420a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content inquiry" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title inquiry" }, "2-4. お問い合わせ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-text inquiry" }, [
  /*#__PURE__*/_createElementVNode("p", null, "国立国会図書館 関西館 電子図書館課 著作権処理係"),
  /*#__PURE__*/_createElementVNode("p", null, "E-mail: ml-chosakuken(at)ndl.go.jp （(at)は半角記号の@に置き換えてください。）")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_ToPageTop)
  ]))
}